export const projectType = {
  AR_CARD: "AR_CARD",
  PRODUCT_VISUALIZER: "PRODUCT_VISUALIZER",
  ECOMMERCE: "ECOMMERCE"
};

export const ProjectStatus = {
    'DRAFT': 'DRAFT',
    'PUBLISHED': 'PUBLISHED',
    'REVIEW': 'REVIEW',
}